'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.getEditor = getEditor;
exports.isEditable = isEditable;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _values = require('lodash/values');

var _values2 = _interopRequireDefault(_values);

var _ajax = require('../utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _notify = require('../notify');

var _notify2 = _interopRequireDefault(_notify);

var _querystring = require('../utils/querystring');

var _querystring2 = _interopRequireDefault(_querystring);

var _event = require('../core/event');

var _event2 = _interopRequireDefault(_event);

var _initialize = require('../core/initialize');

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)('linksoft:datatables:editor');

var editors = new Map();

var states = {
	editable: 'editable',
	editing: 'editing',
	//hasChanges: 'editing has-changes',
	savingChanges: 'saving-changes',
	saved: 'saved',
	error: 'error'
};

// create editor for all editable tables once initialized
(0, _jquery2.default)(document).on('preInit.dt', function (e, settings) {
	if (settings.oInit.editable) {
		var tableElement = e.target;
		(0, _jquery2.default)(tableElement).addClass('editable');
		editors.set(tableElement, new Editor(tableElement));
	}
});

_event2.default.on('linksoft.datatables.createdRow', function (e, row, data) {
	var editor = e.target.DataTable().editor();
	if (editor) {
		(0, _jquery2.default)(row).children().each(function (i, el) {
			return (0, _jquery2.default)(el).toggleClass('editable', isEditable(editor.api.column(i + ':visible'), data));
		});
	}
});
// $(document).on('createdRow.dt', function (e, row, data) {
// 	const editor = getEditor(e.target);
// 	if (editor) {
// 		$(row).children().each((i, el) => $(el).toggleClass('editable', isEditable(editor.api.column(i + ':visible'), data)));
// 	}
// });

/**
 * Insert row functionality, can be used, to insert new entity to table
 * with optional ability to pre-initialize inputs by given data
 * (e.g. taken from existing row) a.k.a. cloning.
 */
// export function insertRow(tableElement, origRow, options) {
// 	const editor = getEditor(tableElement);
// 	if (editor) {
// 		editor.insertRow(origRow, options);
// 	}
// }
//
// export function cancelInsert(tableElement) {
// 	const editor = getEditor(tableElement);
// 	if (editor) {
// 		editor.cancelInsert();
// 	}
// }

function getEditor(element) {
	var tableElement = (0, _jquery2.default)(element).closest('table.dataTable');
	if (tableElement.length > 0) {
		return editors.get(tableElement.get(0));
	}
}

function isEditable(column, data) {
	var editable = column.options().editable;
	switch (typeof editable === 'undefined' ? 'undefined' : _typeof(editable)) {
		case 'boolean':
			return editable;
		case 'function':
			return !!editable(column, data);
	}
	return false;
}

(0, _jquery2.default)(document).on('click', 'table.dataTable.editable tbody tr:not(.insertRow) td', function (e) {
	var editor = getEditor(e.target);
	if (editor) {
		editor.startEdit((0, _jquery2.default)(e.target).closest('td').get(0));
	}
});

(0, _jquery2.default)(document).on('keydown', 'table.dataTable.editable tbody tr td', function (e) {

	var editor = getEditor(e.target);
	if (!editor) return;
	//const cellElement = $(e.target).closest('td').get(0);

	if (e.keyCode === 27) {
		// esc
		editor.cancelEdit();
	} else if (e.keyCode === 13) {
		// enter
		editor.submitChanges();
	} else if (e.keyCode === 9) {// tab
		// TODO: editor.editNext();
	}
});
//
// $(document).on('blur', 'table.dataTable.editable tbody tr td input', function (e) {
// 	log('on table input change: %o', e.target);
// 	const editor = getEditor(e.target);
// 	if (editor) {
// 		editor.submitChanges();
// 	}
// });

/**
 *
 */
(0, _jquery2.default)(document).on('click', 'table.dataTable tbody tr.insertRow div.form-footer a, table.dataTable tbody tr.insertRow div.form-footer button', function (e) {
	log('on table insertRow button click: %o', this);
	var editor = getEditor(this);
	var $this = (0, _jquery2.default)(this);
	if (editor) {
		if ($this.is('.buttons-insert-submit')) {
			editor.submitNewEntity(this);
		} else if ($this.is('.buttons-insert-cancel')) {
			editor.cancelInsert(this);
		}
	}
	return false;
});

// function submitAll() {
// 	editors.forEach(e => e.submitChanges());
// }
//
// function cancelAll() {
// 	editors.forEach(e => e.cancelEdit());
// }

var Editor = function () {
	_createClass(Editor, [{
		key: 'api',
		get: function get() {
			return this._api || (this._api = this.$table.DataTable());
		}
	}]);

	function Editor(tableElement) {
		_classCallCheck(this, Editor);

		this.$table = null;
		this._api = null;
		this._isEnabled = true;
		this.editingCell = null;
		this.originalValue = null;
		this.insertingRow = null;

		this.$table = (0, _jquery2.default)(tableElement);
		// this.init();
	}

	/**
  * Enable/disable editing mode for table.
  * By default it is enabled if the table supports editing.
  * @returns {boolean}
  * @param enabled
  */


	_createClass(Editor, [{
		key: 'setEnabled',
		value: function setEnabled(enabled) {
			return this._isEnabled = !!enabled;
		}

		/**
   * If true, editing is enabled for the table.
   * By default it is enabled if the table supports editing.
   * @returns {boolean}
   */

	}, {
		key: 'isEnabled',
		value: function isEnabled() {
			return this._isEnabled;
		}
	}, {
		key: 'hasState',
		value: function hasState(cellElement, state) {
			return this.getState(cellElement) === state;
		}
	}, {
		key: 'getState',
		value: function getState(cellElement) {
			var $cell = (0, _jquery2.default)(cellElement);
			return $cell.data('editor-state');
		}
	}, {
		key: 'setState',
		value: function setState(cellElement, state) {
			var $cell = (0, _jquery2.default)(cellElement);
			$cell.data('editor-state', state);
			$cell.removeClass((0, _values2.default)(states).join(' '));
			$cell.addClass(state);
		}
	}, {
		key: 'inlineInsert',
		value: function inlineInsert(origRow) {

			this.cancelInsert(); // cancel insert if already in progress

			var origData = origRow && typeof origRow.data === 'function' ? origRow.data() : {};
			var cells = this.api.columns().map(function (column) {
				return { editable: column.editable(origData), column: column, value: origData[column.dataSrc()] };
			}).map(function (x) {
				return '<td>' + (x.editable ? x.column.renderer().createEditor(x.value, 0) : '') + '</td>';
			}).join('');

			var row = (0, _jquery2.default)('<tr class="insertRow">' + cells + '</tr>');

			this.insertingRow = row;

			if (origRow) {
				(0, _jquery2.default)(origRow.node()).after(row);
			} else {
				(0, _jquery2.default)(this.api.table().body()).prepend(row);
			}

			(0, _initialize.trigger)(row);
		}
	}, {
		key: 'formInsert',
		value: function formInsert(url, origRow) {
			var _this = this;

			this.cancelInsert(); // cancel insert if already in progress

			var saveButtonText = this.api.table().i18n('buttons.insertSubmit', '<i class="fa fa-save" />&nbsp;Save');
			var cancelButtonText = this.api.table().i18n('buttons.insertCancel', '<i class="fa fa-cancel" />&nbsp;Cancel');

			var row = (0, _jquery2.default)('<tr class="insertRow"><td colspan="1000">\n\t\t\t<div class="form-container loading">\n\t\t\t\t<div class="form-body" data-ajax-update="#' + this.$table.attr('id') + ' tr.insertRow .form-body"></div>\n\t\t\t\t<div class="form-footer">\n\t\t\t\t\t<a class="btn btn-default buttons-save buttons-insert-submit" tabindex="0" aria-controls="signers" href="#" style="">\n\t\t\t\t\t\t<span>' + saveButtonText + '</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class="btn btn-default buttons-cancel buttons-insert-cancel" tabindex="0" aria-controls="signers" href="#" style="">\n\t\t\t\t\t\t<span>' + cancelButtonText + '</span>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t</td></tr>');
			var eventArgs = { html: row, editor: this };
			_event2.default.trigger('linksoft.datatables.renderingFormInsert', eventArgs);
			row = eventArgs.html;
			this.insertingRow = row;

			if (origRow) {
				(0, _jquery2.default)(origRow.node()).after(row);
			} else {
				(0, _jquery2.default)(this.api.table().body()).prepend(row);
			}
			var $container = row.find('.form-container');
			$container.height(100);
			var $formBody = row.find('.form-container .form-body');
			return (0, _ajax2.default)({ url: url, method: 'get', target: $formBody.get(0) }).done(function () {
				$container.removeClass('loading');
				setTimeout(function () {
					_this._adjustInsertRowHeight(row);
				}, 50);
			});
		}
	}, {
		key: '_adjustInsertRowHeight',
		value: function _adjustInsertRowHeight(row) {
			row = row || this.insertingRow;
			if (row && row.length) {
				var $container = row.find('.form-container');
				$container.css('height', $container.children().toArray().reduce(function (h, e) {
					return h + (0, _jquery2.default)(e).outerHeight(true);
				}, 0));
			}
		}
	}, {
		key: 'cancelInsert',
		value: function cancelInsert() {
			var _this2 = this;

			var row = this.insertingRow;
			this.insertingRow = null;

			return _jquery2.default.Deferred(function ($dfd) {

				if (row) {
					row.find('.form-container').height(0);
					setTimeout(function () {
						row.remove();
						$dfd.resolve();
					}, 200);
				} else {
					$dfd.resolve();
				}
			}).then(function () {
				_event2.default.trigger('linksoft.datatables.insertCancel', { api: _this2.api, editor: _this2 });
			});
		}
	}, {
		key: '_submitNewEntity',
		value: function _submitNewEntity(button) {
			var _this3 = this;

			var insertingRow = this.insertingRow;

			var form = insertingRow.find('form');
			if (form.length) {
				return (0, _ajax.submitForm)(form, button);
			} else {
				// inline insert
				var data = {};
				this.api.columns().map().filter(function (column) {
					return column.editable();
				}) // todo pass origData
				.map(function (column) {
					return {
						key: column.dataSrc(),
						value: column.renderer().getEditorValue()
					};
				}).forEach(function (d) {
					return data[d.key] = d.value;
				});

				return (0, _ajax2.default)({
					url: this.api.ajax.url(),
					method: 'POST',
					contentType: 'application/json',
					data: JSON.stringify(data)
				}).done(function (result) {
					_this3.api.draw();
					_notify2.default.success(_this3.api.i18n('notify.insert.success'));
				}).fail(function () {
					_notify2.default.error(_this3.api.i18n('notify.insert.failed'));
				});
			}
		}
	}, {
		key: 'submitNewEntity',
		value: function submitNewEntity(button) {
			var _this4 = this;

			_event2.default.trigger('linksoft.datatables.inserting', { api: this.api, editor: this, button: button });
			this._submitNewEntity(button).then(function (data) {
				_event2.default.trigger('linksoft.datatables.inserted', { api: _this4.api, editor: _this4, button: button, data: data });
			});
		}
	}, {
		key: 'startEdit',
		value: function startEdit(cellElement) {
			log('start editing: %o', cellElement);
			if (this.editingCell === cellElement) return; // click on editing cell

			if (this.editingCell) {
				this.submitChanges();
			}

			var cell = this.api.cell(cellElement);

			// create editor for current table cell
			if (cell.editable()) {
				this.editingCell = cellElement;
				this.originalValue = this.api.cell(cellElement).data();
				this.setState(cellElement, states.editing);

				var column = this.api.column(cellElement);
				var row = this.api.row(cell.node());
				var input = column.renderer().createEditor(cell.data(), row.id(), row.data());
				var content = (0, _jquery2.default)(cellElement).html(input);
				(0, _initialize.trigger)(content);
				column.renderer().onEditorCreated(content);
			}
		}
	}, {
		key: 'cancelEdit',
		value: function cancelEdit() {
			var cellElement = this.editingCell;
			var originalValue = this.originalValue;
			this.editingCell = null;
			this.originalValue = null;

			var cell = this.api.cell(cellElement);
			if (cell) {
				cell.data(originalValue);
			}
		}
	}, {
		key: 'submitChanges',
		value: function submitChanges() {
			var _this5 = this;

			var cellElement = this.editingCell;
			var originalValue = this.originalValue;
			this.editingCell = null;
			this.originalValue = null;
			if (!cellElement) return;

			// write new value to data table's cell
			var column = this.api.column(cellElement);
			var renderer = column.renderer();
			var value = renderer.getEditorValue(cellElement);
			var cell = this.api.cell(cellElement);
			cell.data(value);
			this.setState(cellElement, states.editable);

			if (typeof value === 'undefined' || value === originalValue) return; // input not found

			var id = this.api.row(cell.node()).id();
			var data = _extends({}, renderer.buildPatchData(cell.data()));

			var targetUrl = _querystring2.default.update(this.api.ajax.url(), function () {
				return {};
			}) + '(' + JSON.stringify(id) + ')';

			this.setState(cellElement, states.savingChanges);
			var eventArgs = {
				api: this.api,
				editor: this,
				cell: cellElement,
				value: value,
				originalValue: originalValue,
				data: data,
				cancel: false
			};
			_event2.default.trigger('linksoft.datatables.savingChanges', eventArgs);
			if (eventArgs.cancel) return;
			(0, _ajax2.default)({
				url: targetUrl,
				method: 'PATCH',
				contentType: 'application/json',
				data: JSON.stringify(data)
			}).then(function () {
				var eventData = {
					api: _this5.api,
					editor: _this5,
					cell: cellElement,
					value: value,
					originalValue: originalValue,
					data: data,
					notify: true
				};
				_event2.default.trigger('linksoft.datatables.changesSaved', eventData);
				if (eventData.notify) _notify2.default.success(_this5.api.i18n('notify.edit.success'));
				_this5.setState(cellElement, states.saved);
				setTimeout(function () {
					if (_this5.hasState(cellElement, states.saved)) {
						_this5.setState(cellElement, states.editable);
					}
				}, 400);
			}).fail(function (e) {
				log('save changes failed %o', e);
				var eventData = {
					api: _this5.api,
					editor: _this5,
					cell: cellElement,
					value: value,
					originalValue: originalValue,
					data: data,
					notify: true
				};
				_event2.default.trigger('linksoft.datatables.savingFailed', eventData);
				if (eventData.notify) _notify2.default.error(_this5.api.i18n('notify.edit.failed'));
				_this5.setState(cellElement, states.error);
				// setTimeout(() => {
				// 	if (this.hasState(cellElement, states.error)) {
				// 		this.setState(cellElement, states.editable);
				// 	}
				// }, 1000);
			});
		}

		// getEntityId(cell) {
		//     const rowData = this.api.row(cell.node()).id();
		//     return rowData.id;
		// }

		// getChangedData(cell) {
		//     const column = this.api.column(cell.node());
		//     const propName = column && column.dataSrc();
		//     const data = {};
		//     if (typeof propName === 'string') {
		//         data[propName] = cell.data();
		//     }
		//     return data;
		// }


		/**
   * Creates editor component for column and initializes it with given value
   * @param column
   * @param value
   */
		// createColumnEditor(column, value) {
		// 	const def = column.options();
		// 	var html = '';
		//
		// 	if (!value) value = '';
		//
		// 	switch (def.filterType || def.type) {
		// 		case "num":
		// 		case "number":
		// 			html = `<input type="number" value="${value}">`;
		// 			break;
		// 		case "date": {
		// 			let date = value;
		// 			html = `<input type="text" value="${date}" data-provider="datepicker">`;
		// 			break;
		// 		}
		// 		case "bool":
		// 		case "boolean":
		// 			html = `<input type="checkbox" ${value ? 'checked' : ''} />`;
		// 			break;
		// 		case "enum":
		// 			var values = column.enumValues();
		// 			var options = values.map(v => `<option value="${v.id}">${v.text}</option>`).join("");
		// 			html = `<select>${options}</select>`;
		// 			break;
		// 		case "lookup":
		// 			if (!def.dataUrl) {
		// 				log('Column with lookup filter requires "dataUrl" to be defined. %o', def);
		// 				return null;
		// 			}
		// 			html = (
		// 				`<select class="form-control table-filter"
		//                data-ajax--url="${def.dataUrl}"
		//                data-odata="true"
		//                data-allow-clear="true"
		//                data-width="resolve"
		//                data-placeholder="${this.api.i18n('Select2Placeholder')}"></select>`);
		// 			break;
		// 		default:
		// 			html = `<input type="text" value="${value}"/>`;
		// 			break;
		// 	}
		// 	return html;
		// }

		// getEditorValue(element) {
		//     const column = this.api.column(element);
		//     // todo: return value base on column type, paired with createColumnEditor
		//     var value = $(element).find('input[type="text"]').val();
		//
		//     if (value === 'null' || value === '') return null;
		//     return value;
		// }

		// isEditableCell(cellElement) {
		//     const options = this.api.columnOptions(cellElement);
		//     const editableType = typeof options.editable;
		//     return editableType === 'boolean' && options.editable
		//         || editableType === 'string ' && this.evaluateEditable(cellElement, options.editable); // TODO: type === 'function'
		// }
		//
		// evaluateEditable(cellElement, expression) {
		//     // TODO: generovani funkce by melo byt reseno na urovni loadovani options, aby se zamezilo opakovanemu zpracovani
		//     const func = new Function('rowData', `(function(rowData){"use strict"; return (${expression});).call(rowData)`);
		//     const rowData = this.api.row(cellElement).data();
		//     var result = func(rowData);
		//     if (typeof result === 'function') {
		//         result = result();
		//     }
		//     return !!result;
		// }

	}]);

	return Editor;
}();


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/editor.js
// module id = 445
// module chunks = 1